import LastMatchProvider from './LastMatchProvider'
import { useLastMatch } from './useLastMatch'
import { withLastMatch } from './withLastMatch'

export {
  useLastMatch,
  withLastMatch
}

export default LastMatchProvider
